export default __webpack_public_path__ + "static/media/league-of-legends-avatar.9eeadf29.png";